var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadAppIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "direct-inbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 2.5V9.5L14.5 7.5",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5007 9.5L10.5007 7.5",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.47949 13.5H6.88949C7.26949 13.5 7.60949 13.71 7.77949 14.05L8.94949 16.39C9.28949 17.07 9.97949 17.5 10.7395 17.5H14.2695C15.0295 17.5 15.7195 17.07 16.0595 16.39L17.2295 14.05C17.3995 13.71 17.7495 13.5 18.1195 13.5H22.4795",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.49927 4.62891C3.95927 5.14891 2.49927 7.22891 2.49927 11.4989V15.4989C2.49927 20.4989 4.49927 22.4989 9.49927 22.4989H15.4993C20.4993 22.4989 22.4993 20.4989 22.4993 15.4989V11.4989C22.4993 7.22891 21.0393 5.14891 17.4993 4.62891",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAppIcon);
export default __webpack_public_path__ + "static/media/download_app_icon.9a9b3bdcff4afac3fd9a9d59411a8bfd.svg";
export { ForwardRef as ReactComponent };